import { useEffect } from 'react'
import { useParams, Navigate, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { supportedLanguages, defaultLanguage, type SupportedLanguage } from '@/i18n'

export function LanguageWrapper() {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()

  useEffect(() => {
    if (lang && supportedLanguages.includes(lang as SupportedLanguage)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang)
      }
    }
  }, [lang, i18n])

  if (!lang || !supportedLanguages.includes(lang as SupportedLanguage)) {
    return <Navigate to={`/${defaultLanguage}`} replace />
  }

  return <Outlet />
}
